<template>
    <form @submit.prevent="submit" novalidate="novalidate">
        <span class="p-float-label">
            {{ $t('provideTfaMessage') }}
        </span>
        <span class="p-mb-3 p-field p-col-12 p-d-block p-d-no-padding">
            <label for="tfa-code" v-t="'label.code'"></label>
            <InputText
                autocomplete="one-time-code"
                id="tfa-code"
                v-model="formData.code"
                :class="{ invalid: errors.tfaCode.length }"
            />
        </span>
        <div class="input-error-container p-mb-5">
            <small v-if="errors.tfaCode.length" class="input-error" v-t="'errors.tfaCode.' + errors.tfaCode" />
        </div>
        <Button
            type="submit"
            class="p-button"
            :label="$t('button.submit')"
        ></Button>
    </form>
</template>

<script>
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';

    export default {
        name       : 'TfaAnon',
        components : {
            Button,
            InputText,
        },
        data() {
            return {
                formData : { code : '' },
                errors   : {
                    tfaCode : '',
                },
            };
        },
        watch : {
            'formData.code' : function() {
                this.errors.tfaCode = '';
            },
        },
        methods : {
            isFormValid() {
                let isValid = true;
                if (this.formData.code.length < 1) {
                    this.errors.tfaCode = 'empty';
                    isValid = false;
                }
                return isValid;
            },
            submit() {
                if (!this.isFormValid()) {
                    return;
                }
                const payload = {
                    token : this.$route.params.token,
                    code  : this.formData.code,
                };
                this.$apiClient
                    .post('checkTfaAnon', {}, payload)
                    .then((response) => {
                        let errorMsg = response.data.msg;
                        let view = response.data.view;
                        if (errorMsg !== undefined) {
                            this.$notifier.notifyError(errorMsg, '', 5000);
                        }

                        if (view === 'reset') {
                            this.$parent.isTfa = false;
                            this.$parent.tfaConfirmed = false;
                        }

                        if (view === 'tfa') {
                            this.$parent.isTfa = true;
                            this.$parent.tfaConfirmed = false;
                        }

                        if (view === 'success') {
                            this.$parent.isTfa = false;
                            this.$parent.tfaConfirmed = true;
                        }
                    })
                    .catch((error) => {
                        this.tfaSent = true;
                        this.isTfa = false;
                        this.tfaConfirmed = false;
                        const errorMsg = typeof error === 'string' ? error : this.$i18n.t('errors.default');
                        this.$notifier.notifyError(errorMsg, '', 5000);
                    });
            },
        },
    };
</script>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="./i18n.json" />
